import { render, staticRenderFns } from "./Manuals.vue?vue&type=template&id=2495f706&scoped=true&"
import script from "./Manuals.vue?vue&type=script&lang=ts&"
export * from "./Manuals.vue?vue&type=script&lang=ts&"
import style0 from "./Manuals.vue?vue&type=style&index=0&id=2495f706&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495f706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/intern/customer-portal/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
